import React from "react";

import { isTermsReady } from "state/teachers/selectors";

import MaintainValidSchoolID from "components/teachers/MaintainValidSchoolID";
import Preloader from "components/teachers/Preloader";
import SchoolSelector from "components/teachers/SchoolSelector";
import SchoolCarousel from "components/teachers/SchoolCarousel";
import SchoolTermList from "components/teachers/term_calendar/SchoolTermList";

import "./TermCalendarPage.css";

export default class TermCalendarPage extends React.Component {
  
  isTermsReady = (state) => {
    return isTermsReady(state, this.props.schoolID);
  }
  
  generatePath = (schoolID) => {
    return `/teachers/term_calendar/${schoolID}/`;
  }
  
  render() {
    const { schoolID } = this.props.match.params;
    return (
      <MaintainValidSchoolID currentSchoolID={schoolID} generatePath={this.generatePath}>
        <Preloader isPageReady={this.isTermsReady}>
          <div className="term-calendar-page">
            <div className="page-header">
              <h1 className="page-header__title">Term Calendar</h1>
              <SchoolSelector selectedSchoolID={schoolID} generatePath={this.generatePath} />
            </div>
            <SchoolCarousel activeSchoolID={schoolID} generatePath={this.generatePath}>
              { schoolID => <SchoolTermList key={schoolID} schoolID={schoolID} /> }
            </SchoolCarousel>
          </div>
        </Preloader>
      </MaintainValidSchoolID>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/teachers/term_calendar/TermCalendarPage.js